import { default as ModuleContext } from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { ModalWrapper } from 'components/ModalWrapper';
import TextSearch from 'components/search/TextSearch';
import { useForceRender } from 'hooks/useForceRender';
import CulturalvocModel from 'models/CulturalVocModel';
import React, { useMemo } from 'react';
import { ICulturalVocs } from 'types/culturalvocs';
import { IGridData } from 'types/models';

type IProps = {
  onClose: () => void;
  onChooseCulturalVoc: (data: ICulturalVocs) => void;
  courseId?: number | null;
};

const CulturalVocSearchModal: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();

  const culturalVocModel = useMemo(() => new CulturalvocModel({ render: forceRender, courseId: props.courseId || 0 }), [
    forceRender,
    props.courseId,
  ]);

  const handleRowClick = (data: IGridData) => {
    props.onChooseCulturalVoc(data as ICulturalVocs);
  };

  return (
    <ModalWrapper title="Search Cultural Vocabulary" width={600} height={555} onClose={props.onClose}>
      <ModuleContext.Provider value={culturalVocModel}>
        <TextSearch />
        <Grid handleRowClick={handleRowClick} />
      </ModuleContext.Provider>
    </ModalWrapper>
  );
};

export default CulturalVocSearchModal;
